<template>
  <div class="forum_articles" style="min-width:1440px;">
    <div class="second_banner" >
      <!-- <img class="banner_img" src="../assets/img/union_banner.png" alt /> -->
      <img class="banner_img" :src="img.data.data.url" alt />
    </div>
    <router-view name="his" v-if="isRouterAlive"/>
    
    <div class="second_main animated fadeInUp" style="padding-top:40px;padding-bottom:80px;padding-left:20%;padding-right:20%" v-if="isReloadData">
        <div  style="color:#2A303C;margin-bottom:80px">
          <!-- <span @click="gos" style="cursor:pointer;">首页</span>
          <span><i class="el-icon-arrow-right"></i></span> -->
          <!-- <div v-if="chOrEn!='0'">
            <span @click="go" style="cursor:pointer;">论坛文章</span>
            <span><i class="el-icon-arrow-right"></i></span>
            <span>详情</span>
          </div>
          <div v-else>
            <span @click="go" style="cursor:pointer;">Forum Article</span>
            <span><i class="el-icon-arrow-right"></i></span>
            <span>Detail</span>
          </div>    -->
          <div v-if="chOrEn!='0'"  style="display: flex;justify-content: flex-start;align-items:center;">
            
              <!-- <span @click="gos" style="cursor:pointer;">首页</span>
              <span><i class="el-icon-arrow-right"></i></span> -->
              <!-- <span @click="go" style="cursor:pointer;">展览交流</span>   -->
              <!-- <span><i class="el-icon-arrow-right"></i></span>
              <span>详情</span> -->
                <i class="el-icon-caret-right" style="font-size:24px;color:#24367D"></i>
                <span @click="go" style="font-weight: bold;font-size:20px;cursor:pointer;color:#24367D">论坛文章</span>  
                <span><i class="el-icon-arrow-right"></i></span>
                <span style="font-weight: bold;font-size:20px;color:#24367D">详情</span>
            </div>
            <div v-else  style="display: flex;justify-content: flex-start;align-items:center;">
              <!-- <span @click="go" style="cursor:pointer;">Exhibition & Communication</span>
              <span><i class="el-icon-arrow-right"></i></span>
              <span>Detail</span> -->
              <i class="el-icon-caret-right" style="font-size:24px;color:#24367D"></i>
              <span @click="go" style="font-weight: bold;font-size:20px;cursor:pointer;color:#24367D">Forum Article</span>  
              <span><i class="el-icon-arrow-right"></i></span>
              <span style="font-weight: bold;font-size:20px;color:#24367D">Detail</span>
              <!-- <div id="pointer" @click="go">Forum Article</div>
              <div id="before"> </div>
              <div id="pointers" style="margin-left:10px">Detail</div>
              <div id="before"> </div>
              <div id="after"> </div>
              <div id="pointerss" style="margin-left:10px"></div>
              <div id="before"> </div>
              <div id="after"> </div>
              <div id="pointersss" style="margin-left:10px"></div>
              <div id="before"> </div>
              <div id="after"> </div>
              <div id="pointerssss" style="margin-left:10px"></div>
              <div id="before"> </div>
              <div id="after"> </div> -->
            </div>        
          <!-- <svg t="1608204057417" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1154" width="50" height="50"><path d="M522.098 825.237L100.015 512.978l425.313-311.415-1.134 219.033-63.999-0.34 0.476-92.029-252.686 185.017 250.767 185.52 0.483-93.125 63.999 0.332z" fill="" p-id="1155"></path><path d="M927.996 895.639l-78.278-94.295c-1.197-1.439-121.436-145.06-219.643-174.439-69.697-20.852-114.845-15.182-135.555-9.947-6.043 1.528-9.195 2.856-9.249 2.879 0.278-0.119 0.416-0.188 0.416-0.188l-26.283-55.152c1.749-0.809 8.34-3.67 19.736-6.551 26.979-6.82 84.795-14.502 168.914 10.664 55.892 16.72 114.489 60.758 160.868 102.699-23.124-61.906-58.291-131.924-106.667-165.366-50.304-34.774-108.331-48.518-148.151-53.924-44.252-6.006-76.694-3.377-77.017-3.35l-5.46-60.687c6.071-0.535 150.03-12.189 266.165 68.095 50.1 34.633 93.374 99.532 128.62 192.895 25.459 67.437 37.108 124.773 37.591 127.181l23.993 119.486z" fill="" p-id="1156"></path><path d="M458.909 320.962l64-0.333 0.667 128.214-64 0.333zM459.204 564.498h63.874v52.169h-63.874z" fill="" p-id="1157"></path></svg> -->
        </div>
        <div class="articles_content">
          <p></p>
          <div v-html="list">{{list}}</div>
                <!-- <h2>刍议建设东北亚雕塑文化名城</h2>
                <div class="articles_time">2017-05-20 宗合声 长春政事儿</div>
                <p>
                城市雕塑是现代城市建设的重要组成部分，既是独立的艺术品，也是提升城市品位，彰显城市人文精神的重要艺术形式。去年以来，君正书记高度重视城市建设工作，多次明确提出，“要坚持以强烈的文化意识指导城市建设”，特别是在市第十三次党代会上，进一步强调了长春未来要创建“东北亚现代文化名城”的目标。经过研究分析，笔者认为，利用3年左右的时间，借助当前城市交通秩序整治和旧城更新改造的良好势头，举全市之力打造东北亚雕塑文化名城，将是长春建设东北亚现代文化名城的有效载体。
                </p>
                <h3>长春建设东北亚雕塑文化名城的必要性及现实基础</h3>
                <div class="start">
                <i class="iconfont icon-xingxing"></i>
                <span>从世界城市发展史看——</span>
                </div>
                <p>
                雕塑是传承历史文化和彰显时代特征的重要载体。雕塑最早起源于新石器时代，主要用于宗教祭祀，随着人类文明的发展，雕塑艺术与城市逐步结合，成为城市文化的重要组成部分。从古埃及的狮身人面像到希腊的雅典卫城，从巴黎的埃菲尔铁塔到纽约的自由女神，雕塑作为一种相对永恒的艺术形式被广泛应用，在人类城市发展进程中起到了重要的文化载体和城市地标作用。它们或彰显城市的文化特质，或凝聚城市的形象与气质，或凸显城市的性格与个性，或承载公众的理想与需求，最终积淀成为城市的象征与符号。我国真正意义上的城市雕塑概念，形成于20世纪中西文化的碰撞、交流与融合。当时，青岛、上海、威海等城市出现了一批受西方影响的城市雕塑，一定程度上促进了我国城市雕塑的发展。20世纪80年代，随着改革开放，我国雕塑艺术得到空前发展，逐步产生了一批具有代表性的雕塑作品，如广州的“五羊”、珠海的“渔女”、深圳的“拓荒牛”、兰州的“黄河母亲”等。
                </p>
                <p>
                这些雕塑不仅彰显了地域文化和城市精神，而且打破了城市几何建筑造型的呆板，作为一道亮丽的城市风景线，促进了当地旅游业发展，带来了直接经济效益。可以说，城市雕塑艺术因具有其他艺术形式难以比拟的文化功能、调节功能和经济功能，已成为现代城市发展必不可少的元素。
                </p>
                <div class="start">
                <i class="iconfont icon-xingxing"></i>
                <span>从东北亚区域城市现有发展情况看——</span>
                </div>
                <p>
                长春打造东北亚雕塑文化名城具有显著的现实可行性。东北亚板块共有中国、俄罗斯、日本、朝鲜、韩国、蒙古六国，区域内的主要城市雕塑发展水平高低各有不同，总体发展水平相对滞后。其中发展比较好的有韩国的首尔，城市街头约有6000多件雕塑，市中心主干道上几乎每隔三五十米就有一件雕塑作品，城市环境、雕塑艺术与人自然融为一体，形成了一定的规模和特色；日本的城市公共雕塑建设始于第二次世界大战后，不过雕塑作品多数陈列在美术馆、博物馆，每年雕塑展并不多，而且很少得到政府的资金支持，雕塑等艺术文化发展水平一般；大连的城市雕塑有千余座，散落在城市的公园、广场、街头、校园等处，多数体现体育运动、海洋、居民日常生活等主题，其中大型足球雕塑等优秀作品已成为大连的标志；哈尔滨的中央大街上现存着一批造型各异的城市景观雕塑，斯大林公园内的城市景观雕塑一度全国闻名，但随着时间的流逝逐渐被淹没，因“原地踏步”而居于各城市之后；沈阳作为一个老工业城市，在长期城市发展过程中也积累了一些城市雕塑，其中不乏有沈阳北站的太阳鸟等优秀作品，但现存雕塑多以个体形式出现，系统性不强。综合分析判断，目前在东北亚板块范围内，还没有一个名副其实的雕塑名城。长春2010年在中国城市竞争力研究会发布的“中国城市2009十佳雕塑城”中，超越大连、上海、北京、深圳、台州、青岛、广州、苏州和铜陵，跃居榜首，2009年在由国家住建部和文化部联合举办的“新中国城市雕塑建设成就奖”评选中，“长春世界雕塑园”和“人民英雄纪念碑浮雕”等60个城市雕塑项目一起，荣获“新中国城市雕塑建设成就奖”，可以说，不论从雕塑发展规模还是在国内国际的影响力，均处于领先位置，且有很大潜力。我们相信，通过2-3年的努力，把长春打造东北亚区域的雕塑名城具有现实可行性。
                </p>
                <div class="start">
                <i class="iconfont icon-xingxing"></i>
                <span>从长春自身发展实际看——</span>
                </div>
                <p>
                建设雕塑文化名城具有坚实的现实基础。长春是一座年轻的城市，城市雕塑随着城市发展经历了从无到有、从小到大的发展历程，最早有文字记载的雕塑出现在1921年，为日本人所建，1949年以后建设了一批以历史英雄人物和重要事件为题材的纪念性主题雕塑，雕塑真正作为我市城市公共艺术发展起来，改革开放后，又建设了一批为新中国建设做出突出贡献的先进人物和反映城市风貌的主题雕塑，从1997年成立长春市城市雕塑规划管理办公室，举办首届中国长春国际雕塑作品邀请展开始，长春的城市雕塑进入了一个快速发展时期，这一时期，我市雕塑作品数量和质量得到了较快提升，城市雕塑建设的国际化风格日渐形成，其影响力和知名度大幅度提高。至今，我市已举办了4届中国长春世界雕塑大会和17届中国长春国际雕塑作品邀请展，来自世界200多个国家和地区的3000余名雕塑家和文化学者参会，在国内外产生了重大影响。2003年建成的以“友谊·和平·春天”为主题的长春世界雕塑园，公园占地面积91.5公顷，收藏了216个国家和地区的401位雕塑家的451件（组）雕塑作品。到目前为止，长春世界雕塑园作品数量和国际性堪称世界之最。今年2月17日，长春世界雕塑园被国家旅游局评为国家5A级景区。目前，1000余尊各类雕塑矗立在长春的城市广场、街路和公园，雕塑已成为长春的靓丽风景，成为长春文化的重要组成部分，雕塑艺术已经深深融入城市的文化内涵，使长春的文化底蕴和知名度得到了大幅度的提升，打造东北亚雕塑名城的坚实雕塑文化基础已经形成。
                </p>
                <h3>长春建设东北亚雕塑文化名城应吸取的基本经验</h3>
                <p>
                西方城市雕塑作品与传统建筑物、建筑空间密切融合，与特定宗教、历史、文化密切相关，具有浓厚的人文底蕴，宗教建筑上的雕塑作品和建筑周边雕塑景观充分体现了这一特色，纵观西方城市雕塑，可以明显感受到城市雕塑的历史延续性、文化传承性和审美连续性。近年来，我国城市雕塑逐步进入高速发展期，涌现出了许多优秀作品，但总体上看，我国城市雕塑建设水平，与国外城市雕塑的发展建设相比还有很大差距。长春市作为后发城市，在城市雕塑发展上，应坚持“立足吉林看长春、放眼全国看长春、走向世界看长春”的战略思维，充分吸取国内外城市雕塑发展的经验和教训，努力走出一条具有长春特色的城市雕塑发展新路。在打造雕塑文化名城过程中，应注重几个方面的结合：
                </p>
                <div class="start">
                <i class="iconfont icon-xingxing"></i>
                <span>城市历史与城市文化相结合</span>
                </div>
                <p>
                城市雕塑以城市发展的历史为主线，凝聚着城市精神和传统，代表着每一个历史时期的精神面貌。城市雕塑要在尊重历史文化的基础上，重视区域文化和地方文化特色的挖掘，比如，罗马城中现有超过10万个雕塑，这不仅包括散落在城市各个角落的历史遗迹，也有与这些古老雕塑相互呼应的现代雕塑，彰显出罗马独一无二却又不断发展的城市文化。深圳“拓荒牛”雕塑作品，体现了深圳作为经济特区拓荒者的形象，代表了积极向上的开拓精神，是深圳历史文化最突出的象征。目前，在我国一些城市中，城市雕塑存在着盲目跟风的现象，公式化、概念化的“抽象雕塑”，简单的模仿、抄袭，雕塑作品大同小异，缺乏新意、缺少特点，不能充分表现出城市的历史文化。未来长春在城市雕塑建设中，要力戒这方面问题，重视挖掘长春独特的文化资源，真正把长春的汽车文化、电影文化、警示文化、生态文化等文化元素融入到城市雕塑建设过程中，让雕塑来记录长春城市的历史，传播城市的文化，彰显城市的品位。
                </p>
                <div class="start">
                <i class="iconfont icon-xingxing"></i>
                <span>雕塑规划与城市规划相结合</span>
                </div>
                <p>
                国外城市一般都会将城市雕塑作为规划的重要部分，根据不同城市环境、设计需求与要求，整体规划出所需要的城市雕塑的数量与主题，再结合具体文化及功能的需求进行创作。早在1991年，深圳就成立了雕塑院，并制定了城市雕塑总体规划，随后上海、北京、西安、苏州、哈尔滨等国内大型城市也都出台了各自的城市雕塑规划。纲举目张，建议市里尽快着手研究制定长春市城市雕塑总体规划。总规制定过程中可以广泛借鉴现有经验，结合我市区位优势、文化优势、基础优势，聘请国内外经验丰富的顶尖规划设计团队，重点明确城市雕塑发展方向、总体布局结构、区域布局结构、文化主题风格、建设管理权责等，特别是要把雕塑规划纳入到城市总体规划体系当中，把雕塑建设管理有机融合到城市建设管理之中，增强雕塑规划的可执行性与法律效力，有效指导我市雕塑事业发展。
                </p>
                <div class="start">
                <i class="iconfont icon-xingxing"></i>
                <span>贴近生活与时代精神相结合</span>
                </div>
                <p>
                城市雕塑作为一种大众艺术形式，来源于生活，建设也应扎根于群众，在造型、构思、材料上敢于打破旧的惯例，引进现代雕塑观念和手段来丰富雕塑语言，与现代城市生活需要相结合，更多地体现群众性、时代性和发展性。例如，挪威奥斯陆的维格兰雕塑公园，以人生为主题，整个公园基本都是人体类雕塑，看似单调，却展示了生生死死的人生旅程、喜怒哀乐的人间百态，不落俗套、令人震撼。君正书记一直强调，坚持以人民为中心，长春在雕塑城建设过程中，也应认真贯彻落实这一重要指导思想，真正让广大市民参与进来，把“宽容大气、自强不息”的城市精神融入进来，让长春市民在参与雕塑城创造过程中，进一步提升建设管理城市的主人翁责任感和荣誉感。
                </p>
                <div class="start">
                <i class="iconfont icon-xingxing"></i>
                <span>政府推动与市场运作相结合</span>
                </div>
                <p>
                城市雕塑的发展不仅需要雄厚的城市经济基础做支撑，同时还需要充分发挥市场的作用，利用市场的力量来带动城市雕塑产业的发展。例如，上海市建立了市、区（县）两级城市雕塑财政资金投入体系，设置城市雕塑财政专项资金，用于市级城市雕塑项目建设、维护以及各区（县）城市雕塑建设项目补贴，此外，通过鼓励建设单位自筹、企事业单位资助和社会捐款等多渠道筹集资金。在推进城市雕塑产业化方面，西安充分利用雕塑资源，大力推进雕塑产业发展，建立专业雕塑园区，积聚大量雕塑生产企业，有力促进了城市雕塑的发展。这些基本经验我们应认真吸收，确保更加科学有效地推动雕塑城建设。
                </p>
                <h3>长春建设东北亚雕塑文化名城的路径设想</h3>
                <p>
                建设雕塑城是一项系统工程，客观分析当前长春雕塑事业发展现状，应该说，更多的雕塑作品还是局限于园区展示、作品陈列、艺术鉴赏、环境装饰等方面，无论数量和品质，还是建设和管理，与城市发展定位、群众物质文化需求等方面还存在一定差距。所以，未来3年时间，长春雕塑城建设应认真践行“五大发展”理念，深入贯彻中央城市工作会议精神，按照市第十三次党代会的部署，立足吉林看长春、放眼全国看长春、走向世界看长春，突出“以强烈的文化意识指导城市建设”的战略思想，坚持“以人民为中心”的工作理念，坚持近中远期相结合，坚持为城所用、为境所融、为民所享，加快构建“一心、一轴、多带、多点”的雕塑空间布局，推动雕塑事业和雕塑产业“双提升”，全面深化城市公共艺术内涵，提升公共空间环境质量，真正把长春打造成为东北亚雕塑文化名城。
                </p>
                <p>重点把握好以下几方面工作：</p>
                <p>
                1、坚持以“为城所用，为境所融，为民所享”的发展理念为引领。认真落实习近平总书记城市工作会议重要讲话精神，坚持以人民为中心的思想，坚持政府推动、建管并重的原则，围绕打造东北亚雕塑文化名城，依托长春世界雕塑园，继续搭建面向世界的雕塑艺术创作、交流、展示平台，努力让雕塑从公园中走出来，走进广场、走进街路、走进社区，真正与百姓的生活相融合，擦亮“雕塑之城”名片，把整个城市打造成为“没有围墙的公共文化艺术空间”。
                </p>
                <p>
                2、全面构建“一心、一轴、多带、多点”的雕塑空间布局。根据我市城市规划空间布局要求，结合城市公共空间、文脉特点特别是长春城市建设格局的新变化，按照城市雕塑空间、题材、体量三要素合理配置，建议规划构建“一心、一轴、多带、多点”雕塑建设布局。“一心”，即以国家5A级景区长春世界雕塑园为中心，坚持“突出品牌、特色创建、坚持标准、完善提升”的原则，进一步提高入园收藏雕塑的品质和门槛，汇集展示世界顶级雕塑大师作品，打造一流设施、一流环境、一流服务的世界级雕塑名园。“一轴”，即伊通河两岸雕塑景观轴，以伊通河综合治理工程为依托，结合伊通河流域水、景、业、文等元素的布局和配置，突出历史、人文、生态题材，划分出特定区域，用雕塑集中展示长春的母亲河在历史和现代文明交融中的活力和魅力。“多带”，以城市主要街路为依托，结合区域产业特点、文脉特色、风貌特征，打造一批体现空间立体性、平面协调性、文脉延续性的城市雕塑纽带。着力打造文化街区雕塑带，依托红旗街电影文化主题街路、新民大街历史文化街区、吉柴历史文化街区等，集中布局一批以电影、警示、民俗、工业文明为题材的主题性雕塑、陈列性雕塑、纪念性雕塑。着力打造交通干道雕塑带，依托人民大街、吉林大路、机场大道、“两横三纵”快速路等主要街路，差别化布局一批彰显闯关东精神、彰显城市特质、彰显老工业基地振兴发展成果的主题雕塑，塑造不同街路的文化标识，使广大人民群众通过城市雕塑感受城市的发展变化，感受城市的昨天、今天和明天。着力打造商业街路雕塑带，依托桂林路、重庆路、欧亚卖场、巴蜀映巷等重点商街，突出功能性、协调性、多样性相结合，布局一批体现商业、旅游题材，贴近群众生活的雕塑，让雕塑真正成为城市生活的一部分。“多点”，即围绕机场迎宾路、长春火车站等城市门户，规划展览馆、体育馆等公共场所，街心公园、城市广场等重要节点，结合旧城改造提升工程，因地制宜布局一批功能性、装饰性雕塑，让雕塑走进社区、走进广场，融入群众生活。
                </p>
                <p>
                3、按照“三步走”的路径有序推进雕塑文化名城建设。坚持系统思维，明确时间节点，采取项目运作方式，力争用3年左右的时间，通过由点及线到面，分区域、分时段、分步骤推进雕塑建设，使城市特色进一步彰显，城市品位进一步提升。第一阶段：抓重点、建设雕塑地标。利用一年左右的时间，结合长春通透大气的城市环境以及汽车、电影、冰雪等特色文化，面向国际国内集中征集10-20个左右地标性雕塑，经有关部门审批和征求广大群众意见后，重点摆放在城市门户、交通要道、城市广场、城市商圈等主要节点，形成若干以雕塑为载体的文化标识，打造城市名片。第二阶段：做样板、打造雕塑轴带。将雕塑项目建设纳入我市历史文化街区和特色街区建设计划，选择2-3条符合条件的街路，明确鲜明主题，进行整体设计，集中布局城市雕塑，打造若干雕塑文化街路。特别是随着今年伊通河综合治理主体工程完工，加快推进雕塑在沿线的布局、设计和建设，打造集园林、生态、历史等主题于一体的雕塑轴带。第三阶段：优布局、塑造雕塑空间。全方位推进雕塑进街路、进广场、进社区、进校园，无论是住宅小区、大型场馆还是重要街路、主题公园，都要预留城市雕塑用地，进行雕塑的规划与建设，让雕塑与各类建筑融为一体，让雕塑大面积地走进公共场所，让广大市民徜徉在没有围墙的公共文化空间里，以雕塑塑城市之形、传城市之神、化城市之境。
                </p>
                <p>
                4、启动实施雕塑文化和雕塑产业“双提升”计划。文化是城市的灵魂，城市是凝固的文化。通过雕塑城建设，既要把长春文化的“魂”通过雕塑的“形”展示出来，更要通过雕塑的普及、推广和应用，提高城市雕塑对人民群众物质和精神生活的影响力，实现社会效益和经济效益的双提升。加快雕塑文化普及。科学设计活动载体，深入开展“百万市民看雕塑”大型活动，将每年1月份和8月份定为长春世界雕塑园游园月，将长春世界雕塑园及其它雕塑主题公园作为全市中小学、大学生的艺术教育基地。加大文化普及力度，将雕塑知识普及活动纳入社区文化活动，由宣传部门组织安排雕塑艺术专业人士和教师，定期开设雕塑文化大讲堂。培育雕塑会展品牌。无论是雕塑“形”的摆放还是“神”的传递，平台和载体的搭建是关键。高标准办好每三年一届的中国长春世界雕塑大会，继续办好每年一届的中国长春国际雕塑作品邀请展，突出国际化与地域化特点，增加专题雕塑展、国际名家雕塑展、国际企业雕塑展、全国青少年雕塑展、全国美术院校毕业生雕塑展等，实现展览形式多样化。发展雕塑文化产业。市场经济条件下，文化艺术只有融入经济社会发展才会具有更强的生命力。结合老旧工业厂房改造、服务业集聚区建设、特色街区创建，研究设立雕塑产业园，鼓励雕塑专家团队进驻成立雕塑工作室，引进一批国内外知名雕塑企业，探索建立与动漫产业园、广告创意产业园、人力资源产业园合作模式，努力建设集作品设计、人才培养、展示运营等一体化的雕塑园区，加快雕塑产业化步伐，用2-3年的时间，把雕塑产业打造成为占据东北亚市场的支柱产业。
                </p>
                <h3>长春建设东北亚雕塑文化名城的保障机制</h3>
                <p>
                1、建立高层统筹的组织保障机制。现在我市主要是由长春市城市雕塑规划管理办公室（正局级建制）负责全市雕塑规划和建设工作，各县（市）区、开发区的雕塑工作由所在辖区的城市建设管理部门负责。但建设雕塑城市，涉及宣传、文化、城建、规划以及一些企事业单位，因此现有机构无法形成统一领导、统一规划、统一指导、统一建设、统一管理的良性机制。建议比照长春市城乡规划委员会模式，成立由市委市政府主要领导直接挂帅的长春市城市雕塑工作领导小组或委员会（1985年上海即已成立雕塑委员会），将现有的城市雕塑规划管理办公室作为领导小组日常工作机构，定期组织召开例会，从全市角度统筹研究推进雕塑工作，为打造东北亚雕塑文化名城提供坚强组织保证。
                </p>
                <p>
                2、建立多元共享的物质保障机制。主要包括资金筹措机制和作品征集机制。资金筹措方面，可以借鉴国内外相关经验，坚持多元化、市场化运作思路，建议市里设立雕塑文化发展基金，面向全社会多渠道筹集资金。对于日常雕塑建设管理维护费用，可以采取市财政拿出一部分，各县（市）区、开发区配套一部分，参与雕塑建设展示的企事业单位、社会组织、雕塑家自筹一部分等方式，也可以将部分雕塑以拍卖、冠名的方式推向市场，既可解决部分资金，还可提高社会参与程度，一举两得。作品征集方面，坚持共建共享思路，雕塑是公共文化产品，价值在于展示浓厚城市文化，所有权归属并不重要，因此应以不求所有、但为所用、各取所需为原则，广泛面向国内外征集作品，既可长期布置陈列、又可短期展示宣传，既可在室内集中展示，又可在城市公共空间展示，满足不同主体需要。
                </p>
                <p>
                3、建立开放包容的人才保障机制。从文化层面上看，缺乏艺术家的城市必然缺乏生机活力。繁荣城市雕塑文化最关键的是要汇聚一大批雕塑艺术人才，并为他们施展才华提供平台和保障。建议充分释放长春科教文化优势和人才优势，将艺术人才培养引进纳入到全市的人才培养计划中，充分利用现有资源加大相关高校艺术学科建设和专业人才培养力度；可以借鉴柏林现代艺术中心、巴黎蓬皮杜艺术中心、北京798艺术中心等国际顶级文化艺术中心建设先进经验，由市里和各县（市）区、开发区、社会组织、有实力的企业、大学联合打造艺术中心、艺术家工作室、创意工厂、雕塑建设企业孵化基地等，为艺术家特别是正处在成长阶段的青年艺术家成才成长成就提供空间和平台。另外，建议市财政和区财政划出专项资金为培养引进雕塑艺术人才提供必要物质保障。
                </p>
                <p>
                4、建立以人为本的宣传保障机制。城市雕塑彰显的是城市文化、城市精神、城市气质，城市雕塑文化归根结底是市民文化。繁荣城市雕塑文化必须坚持以人为本，最大限度发挥广大市民文化创造主体、文化享有主体、文化传播主体的根本性作用，全市各相关部门应该充分相信人民群众的创造力和鉴赏力，多设计组织一些面向人民群众的雕塑文化类活动，真正让全体市民深入参与到雕塑规划、设计、制作、展示和雕塑文化传播的各个环节，把雕塑放入城市，把文化根植人心。各级各类宣传部门应进一步加大宣传力度，综合利用各种媒介平台，特别是互联网和手机移动平台，集中持续地宣传雕塑对于繁荣城市文化的重要意义和巨大推动作用，普及雕塑文化知识，展示优秀雕塑作品，切实在全市形成重视雕塑文化、热爱雕塑文化、传播雕塑文化的浓厚氛围。
                </p> -->
        </div>
    </div>
    
  </div>
</template>
<script>
import { detailsForum,getByNav } from '../api/api'
export default {
  name: "company",
  data() {
    return {
      list:'',
      img:'',
      isReloadData: true  
    };
  },
  computed: {
  	chOrEn(){
  		return sessionStorage.getItem('chOrEn')
  	}
  },
  created(){
	  let chOrEn = this.$route.query.chOrEn
	  if(!chOrEn){
	  	    this.$router.push({
	  	    path: '/forumArticles',
	  	    })
	  }else{
	  	chOrEn === '0' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh';
	  	sessionStorage.setItem('lang',this.$i18n.locale)
	  	sessionStorage.setItem('chOrEn',chOrEn)
	  }
    let navigationId = {
      id:this.$route.query.list
    }
    detailsForum({...navigationId}).then(res=>{
      console.log(res.data)
        this.list=''
        // this.num = res.data.page.total
        // this.list.list = res.data.data.content
        console.log(this.list)
        this.list = res.data.data.content
        // debugger
        // this.reload()
    })
    let getBynavid = {
      navigationId:5
    }
    getByNav({...getBynavid}).then(res=>{
      this.img = res
    })
  },
  mounted(){
    this.button()
    // this.$router.go(0)
    // let navigationId = {
    //         id:this.$route.query.list
    // }
    // detailsForum({...navigationId}).then(res=>{
    //     this.list=''
    //     // this.num = res.data.page.total
    //     this.list = res.data.data.content
    //     // debugger
    //     // this.reload();
    // })
  },
  methods:{
    go(){
         this.$router.go(-1)
    },
    gos(){
        this.$router.push('/home')
    },
    button(){
      // this.$router.go(0)
      let navigationId = {
              id:this.$route.query.list
      }
      detailsForum({...navigationId}).then(res=>{
          this.list=''
          // this.num = res.data.page.total
          this.list = res.data.data.content
          // debugger
          // debugger
          this.reload();
      })
    },
    reload () {
      this.isReloadData = false;
      this.$nextTick(() => {
        this.isReloadData = true;
      })
    }
  }
};
</script>

<style lang="less" scoped>
.banner_img{
    height:400px
}
#pointer {
    //   width: 200px;
        height: 40px;
        color: #FFFFFF;
        position: relative;
        font-weight: 400;
        background: #CFCFCF;
        font-size: 18px;
        line-height: 25px;
        padding:2px 30px 2px 15px;
        display: flex;justify-content: flex-start;align-items:center;
    }
    #pointers {
    //   width: 200px;
        height: 40px;
        color: #FFFFFF;
        position: relative;
        font-weight: 400;
        background: #2539B4;
        font-size: 18px;
        line-height: 25px;
        padding:2px 30px 2px 15px;
        display: flex;justify-content: flex-start;align-items:center;
    }
    #pointer:before {
      content: "";
      position: absolute;
      right: -0px;
      bottom: 0;
      width: 0;
      height: 0;
      margin-left:3px;
      border-right: 20px solid white;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
    #pointers:before {
      content: "";
      position: absolute;
      left: -20px;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid #2539B4;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }

    #pointers:after {
      content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid white;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
    #pointerss {
      width: 5px;
      height: 40px;
      position: relative;
      background: #CFCFCF;
    }
    #pointerss:after {
      content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid white;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
    #pointerss:before {
      content: "";
      position: absolute;
      left: -20px;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid #CFCFCF;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
    #pointersss {
      width: 5px;
      height: 40px;
      position: relative;
      background: #CFCFCF;
    }
    #pointersss:after {
        content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid white;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
    #pointersss:before {
        content: "";
      position: absolute;
      left: -20px;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid #CFCFCF;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
    #pointerssss {
        width: 0px;
        height: 40px;
        position: relative;
        background: #CFCFCF;
    }
    #pointerssss:after {
        content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid #CFCFCF;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
.forum_articles {
  width: 100%;
  // height: 100%;
  /deep/ .el-tabs__item {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  /deep/ .el-tabs--left .el-tabs__item.is-left{
    text-align: left;
    font-size:18px
  }
  .second_main {
    .articles_content {
      p {
        color: #606060;
      }
      .img_box {
        text-align: center;
        .articles_img {
          margin: 15px auto;
        }
        span {
          font-size: 16px;
          line-height: 30px;
        }
      }
      h2 {
        font-size: 18px;
        color: #2f2f2f;
        font-weight: 800;
        line-height: 40px;
        text-align: center;
      }
      .articles_time {
        font-size: 14px;
        color: #466ec1;
        text-align: center;
        line-height: 30px;
        margin-bottom: 20px;
      }
      h3 {
        font-size: 16px;
        line-height: 30px;
        margin: 0 auto;
        font-weight: 600;
        width: 200px;
        text-align: center;
        //color: #7b0c00;
        margin-bottom: 20px;
      }
      .start {
        display: flex;
        align-items: center;
        height: 40px;
        .iconfont {
          //color: #2d8ff1;
          font-size: 20px;
        }
        span {
          //color: #2d8ff1;
        }
      }
      .img {
        margin: 20px auto;
      }
      h4 {
        margin: 10px 0;
      }
      h5 {
        text-align: right;
      }
    }
  }
}
</style>